export const getCookie = (name) => {
  const cookieName = name + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(cookieName) === 0) {
      return c.substring(cookieName.length, c.length);
    }
  }
  return '';
};

export const setExpiredDate = (days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toGMTString();
  return expires;
};

export const setCookie = (name, value, days) => {
  const expires = setExpiredDate(days);
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
};
